// Note, this wrapper is taken from the @nova/react library.  The use of the wrapper directly in @nova/react will cause
// webpack to inadvertently dead code remove the @graphitation implementation of the tag, so we're instead directly
// calling into the @graphitation library in our code.
import { graphql as graphqlJsTag } from "@graphitation/graphql-js-tag";
/**
 * An opaque type used to annotate a GraphQL document.
 */
export type GraphQLTaggedNode = {
  __brand: "GraphQLTaggedNode";
};
/**
 * This tagged template function is used to capture a single GraphQL document, such as an operation or a fragment. When
 * a document refers to fragments, those should be interpolated as trailing components, but *no* other interpolation is
 * allowed. Put differently, the documents themselves should be entirely static, which allows for static optimizations.
 *
 */
export function graphql(
  document: TemplateStringsArray,
  ...fragments: GraphQLTaggedNode[]
): GraphQLTaggedNode {
  return graphqlJsTag(
    document,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...(fragments as any[])
  ) as unknown as GraphQLTaggedNode;
}
